export class MessengerHeight {
    constructor(optionalOptions = {}) {
        this._block = document.querySelector('.chat--chat-messages--block');

        if (!this._block) {
            this.destructor();
            return true;
        }

        let documentHeight = window.innerHeight|| document.documentElement.clientHeight||
            document.body.clientHeight;

        let headerHeight = this._block.querySelector('.chat--chat-messages--header').offsetHeight
        let bottomHeight = this._block.querySelector('.chat--chat-message--bottom').offsetHeight

        this._block.querySelector('.chat--chat-messages--body').style.height = (documentHeight - (headerHeight + bottomHeight)) + 'px';
    }

    destructor() {
        this._block = null;
    }
}

export default new MessengerHeight();